/* eslint-disable react/destructuring-assignment */
import * as React from "react";

const LinkIcon = ({ fillColor = "#4096FF" }) => (
  <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.5312 12.4688H2.46875C2.22676 12.4688 2.03125 12.2732 2.03125 12.0312V1.96875C2.03125 1.72676 2.22676 1.53125 2.46875 1.53125H7.39062C7.45078 1.53125 7.5 1.58047 7.5 1.64062V2.40625C7.5 2.46641 7.45078 2.51562 7.39062 2.51562H3.01562V11.4844H11.9844V7.10938C11.9844 7.04922 12.0336 7 12.0938 7H12.8594C12.9195 7 12.9688 7.04922 12.9688 7.10938V12.0312C12.9688 12.2732 12.7732 12.4688 12.5312 12.4688ZM11.0392 2.72249L10.3256 2.00882C10.2613 1.94456 10.2996 1.83382 10.3898 1.82288L12.8426 1.53578C12.9123 1.52757 12.9724 1.58636 12.9642 1.65746L12.6771 4.11019C12.6662 4.20042 12.5554 4.2387 12.4912 4.17445L11.7748 3.45804L8.27205 6.96078C8.22967 7.00316 8.15994 7.00316 8.11756 6.96078L7.53787 6.38109C7.49549 6.33871 7.49549 6.26898 7.53787 6.2266L11.0392 2.72249Z"
      fill={fillColor}
    />
  </svg>
);

export default LinkIcon;
